<template lang="pug">
  .filteroptions
    filter-option(v-for="facet in sortedOptions" 
      v-if="Object.entries(facet[1]).length > 1 || $store.state.listFilter.selections[facet[0]]"
        :key="`${facet[0]}-${facet[1].length}`"
        :option="facet[0]"
        :isNumeric="facet[0] == 'quantity' || facet[0] == 'size'"
        v-on:api-search="$emit('api-search')"
        )
    .chips
      .chip(v-for="selection in selectionsForChips" @click.prevent="removeSelection(selection)") {{ selection.value }} x
      .chip.suggestion(v-for="suggestion in suggestions" @click.prevent="addSelection(suggestion)" v-if="suggestion") {{ suggestion.value }}
    //- label(for="visibility") Papierkorb
    //-   input(type="checkbox" name="visibility" v-model="editVisibility")
    //- pre {{ selections }}
    //- pre {{ suggestions }}
</template>

<script>
import FilterOption from './FilterOption.vue'
export default {
  computed: {
    sortedOptions: function() {
      return [
        "metaCategory",
        "type","color","style","topic","materials",
        "quantity","size","shape","contributor",
        // "taxonomies",
      ].map(e => {
        return this.options.find(findElement => findElement[0] === e);
      }).filter(e => e != null);
    },
    options: function() {
      return Object.entries(this.$store.state.listFilter.facets);
    },
    selectionsForChips: function() {
      const res = {}
        Object.entries(this.$store.state.listFilter.selections).map(([facet, value]) => {
        if(!res[facet]) res[facet] = []
        res[facet] = [...res[facet],value].flat()
      })
      const resFlat = []
      Object.entries(res).map(([facet, values]) => {
        values.map(value => {
          resFlat.push({ facet, value })
        })
      })
      return resFlat
    },
     selections: function() {
      const selections = []
      Object.entries(this.$store.state.listFilter.selections).map(([key, value]) => {
        (value || []).map((e) => {
          selections.push({ facet: key, value: e })
        })
      })
	    return selections.filter(e => !e.value.includes("="));
    },
    suggestions: function () {
      const suggestions = []
      this.sortedOptions.map(([facet, options]) => {
        Object.entries(options).map((e) => {
          if(facet !== "size" && facet !== "quantity" && e[0] !== "none" ) {
            suggestions.push({ facet, value: e[0], count: e[1] })
          }
        })
      })
      suggestions.sort((a,b) => b.count - a.count).filter(e => !this.selections.find(e2 => e2.facet = e.facet && e.value == e2.value));
      if(suggestions.length > this.sortedOptions.length * 3) {
        suggestions.length = this.sortedOptions.length * 3;
      }
      const filtered = suggestions
        .map(({ facet, value }) => ({ facet, value }))
        .filter(({ facet, value }) => !(this.$store.state.listFilter.selections[facet] || []).includes(value));
      filtered.length = 15
      return filtered
    }
  },
  methods: {
    removeSelection({ facet, value }) {
      const currentSelections = this.$store.state.listFilter.selections;
      currentSelections[facet] = currentSelections[facet].filter(e => e != value )
      this.$store.commit('UPDATE_SELECTED_LIST_FILTER', { selections: currentSelections })
      this.$emit('api-search');
    },
    addSelection({ facet, value }) {
      const currentSelections = this.$store.state.listFilter.selections;
      currentSelections[facet] = [...currentSelections[facet] || [],value];
      this.$store.commit('UPDATE_SELECTED_LIST_FILTER', { selections: currentSelections })
      this.$emit('api-search');
    },
  },
  components: {
    FilterOption,
  },
  data: () => ({
    editVisibility: false,
  }),
  watch: {
    'editVisibility': async function (to, from) {
        this.$store.commit('UPDATE_SELECTED_LIST_FILTER_EXCLUSIONS', { exclusions: {
          ...this.$store.state.listFilter.exclusions,
          ["isHidden"]: [String(!to)],
        } })
    }
  },
  mounted () {
    const currentFilter = {}
    Object.entries(this.$route.query).map(([key, value]) => {
      if (key !== "term") {
        currentFilter[key] = decodeURIComponent(value).split(",")
      }
    })
    if (Object.entries(currentFilter).length > 0) {
      this.$store.commit('UPDATE_SELECTED_LIST_FILTER', { selections: currentFilter })
    }
  }
}
</script>

<style scoped lang="sass">
.chip
  display: inline-block
  color: #fff
  background: #c00
  padding: 4px 8px
  margin-right: 8px
  margin-bottom: 4px
  border-radius: 3px
  cursor: pointer
  border: 1px solid #c00
  border-radius: 4px
  text-transform: lowercase
  &.suggestion
    color: #000
    background: #fff
    border: 1px solid #aaa
  &:hover
    color: #000
    background: #aaa
    border: 1px solid #aaa
    text-decoration: underline
</style>
